<template>
  <div class="summary-stat">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据下载汇总统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item  label="数据类别">
          <el-select  size="mini" v-model="searchParams.type" style="width:200px;" 
                      filterable placeholder="Proposal/GRB/SEM/UPK" clearable >
                  <el-option
                      v-for="item in filedataltype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="数据ID">
          <el-autocomplete
          class="inline-input"
            placeholder=""
            style="width: 220px"
            v-model="searchParams.ogs_id"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="用户邮箱">
          <el-autocomplete
          class="inline-input"
            placeholder=""
            style="width: 220px"
            v-model="searchParams.email"
            :fetch-suggestions="proquerySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
       <!-- <el-form-item>  
          <el-button size='mini' type="primary" @click="summary">统计</el-button>
        </el-form-item> -->
      
      </el-form>
      <el-table
        :data="list"
        style="width: 100%"
        @sort-change="sortChange">
        <el-table-column
          type="selection"
          width="55"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="id"
          label="id"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别">
        </el-table-column>
        <el-table-column
          prop="ogs_id"
          sortable="custom"
          label="数据ID">
        </el-table-column>
        <el-table-column
          prop="level"
          sortable="custom"
          label="数据级别">
        </el-table-column>
        <el-table-column
          prop="file_id"
          sortable="custom"
          label="文件ID">
        </el-table-column>
        <el-table-column
          prop="file_len"
          sortable="custom"
          label="文件长度">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮件地址">
        </el-table-column>
        <el-table-column
          prop="user_id"
          sortable="custom"
          label="用户ID">
        </el-table-column>
        <el-table-column
          prop="firsttime"
          sortable="custom"
          label="首次下载时间">
        </el-table-column>
        <el-table-column
          prop="lasttime"
          sortable="custom"
          label="末次下载时间">
        </el-table-column>
        <el-table-column
          prop="mintimelength"
          label="最短一次持续时间"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="maxtimelength"
          label="最长一次持续时间"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="minspeed"
          label="最慢一次平均速度"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="maxspeed"
          label="最快一次平均速度"
          v-if="false">
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {downfiletype} from '../common';
import axios from 'axios';

export default {
  name: 'SummaryStat',
  data() {
    return {
      searchParams: {
        ogs_id: '',
        email:'',
        type:'',
      },
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      orderDirection: null,
      orderProp: '',
      filedataltype: downfiletype,
      restaurants:[],
      prorestaurants:[],
    };
  },
  created() {
    this.getData();
    this.getinitlist();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/SummaryStat', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
      // console.log("authstates",this.currentastates);
    },
    onSubmit() {
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    summary() {
      const params = {
   
      };
      axios.post('/iapi/summary', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('统计完成');
        }else{
          this.$message('数据错误');
        }
      });
      this.getData();
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    proquerySearch(queryString, cb) {
      let prorestaurants = this.prorestaurants;
      let results = queryString ? prorestaurants.filter(this.procreateFilter(queryString)) : prorestaurants;
      cb(results);
    },
    procreateFilter(queryString) {
      return (prorestaurants) => {
        return (prorestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getData();
    },
    getinitlist(){
      axios.post('/iapi/getinitlist').then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.ogsid;
          this.prorestaurants = res.data.email;
        }
      });
    },
  },
};
</script>

<style scoped>
.summary-stat {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>